/**
 * General Contractor Docs panel — the "General Contractor Docs" doc group
 * rendered beside the GC records on the Contacts tab.
 *
 * Why it sits here: the UW confirmations on a GC record (license reviewed,
 * insurance current, completion guaranty provided) are attestations made AFTER
 * reading this group's paperwork (general-contractor-docs.md §2). Keeping the
 * group next to the toggles means the reviewer never leaves the card to check
 * what they are attesting to — and an empty row is the ask, one click from the
 * upload that fills it.
 *
 * The card itself is the shared DocGroupCoverageCard — the Documents tab's
 * DocGroup Coverage content for ONE group — so this panel and the coverage board
 * can't drift. All this file adds is the group key and the Contacts tab's box
 * border.
 *
 * Files stage into the shared upload queue with docGroup/docType prefilled — the
 * Contacts tab mounts the UploadQueueProvider + FixedUploadQueue for that.
 */
import PropTypes from "prop-types";

import DocGroupCoverageCard from "../../shared/DocGroupCoverageCard";
import { BOX_LINE } from "./components/contactsTokens";

export const CONTRACTOR_DOC_GROUP = "General Contractor Docs";

const GeneralContractorDocsPanel = ({ sx, title = CONTRACTOR_DOC_GROUP }) => (
  <DocGroupCoverageCard
    group={CONTRACTOR_DOC_GROUP}
    title={title}
    sx={{ borderColor: BOX_LINE, ...sx }}
  />
);

GeneralContractorDocsPanel.propTypes = {
  sx: PropTypes.object,
  /** Display heading; the GROUP key it reads is always CONTRACTOR_DOC_GROUP. */
  title: PropTypes.string,
};

export default GeneralContractorDocsPanel;
